require('./util/foreach-polyfill');

export default () => {
	let imageOverflows = [];
	let replace = function (target) {
		if ("srcset" in target.dataset) {
			target.srcset = target.dataset.srcset;
		}
		if ("src" in target.dataset) {
			target.src = target.dataset.src;
		}
	};
	if (!!window.IntersectionObserver) {
		let observer = new IntersectionObserver(
			(entries, observer) => {
				entries.forEach(entry => {
					if (entry.intersectionRatio > 0 || !!entry.isIntersecting) {
						replace(entry.target);

						if (entry.target.classList.contains('image--lazy-load')) {
							entry.target.onload = function () {
								entry.target.classList.add('image--lazy-loaded');
								entry.target.classList.remove('image--lazy-load');

								setTimeout(function () {
									if (imageOverflows[entry.target.parentElement]) {
										entry.target.parentElement.style.overflow = imageOverflows[entry.target.parentElement];
									} else {
										entry.target.parentElement.style.removeProperty('overflow');
									}
								}, 1000);
							}
						}

						observer.unobserve(entry.target);
					}
				});
			},
			{
				root: null,
				rootMargin: "0px 0px 50% 0px"
			}
		);
		document.querySelectorAll('img.image--lazy-load').forEach(img => {
			observer.observe(img);
			imageOverflows[img.parentElement] = img.parentElement.style.overflow;
			img.parentElement.style.overflow = 'hidden';
		});
	} else {
		document.querySelectorAll('img[data-src], img[data-srcset]').forEach(img => {
			replace(img);
			if (img.classList.contains('image--lazy-load')) {
				img.onload = function () {
					img.classList.add('image--lazy-loaded');
					img.classList.remove('image--lazy-load');
				}
			}
		});
	}
}
